import { combineReducers } from "redux";
import productReducer from "./productReducer";
import categoryReducer from "./categoryReducer";
import userReducer from "./userReducer";
import shippingReducer from "./shippingReducer";
import addressReducer from "./addressReducer";
import ordersReducer from "./ordersReducer";
import brandReducer from "./brandReducer";
import subcategoryReducer from "./subcategoryReducer";
import resourceReducer from "./resourceReducer";
import statisticsReducer from "./statisticsReducer";
import prescriptionReducer from "./prescriptionReducer";

const appReducer = combineReducers({
    productReducer: productReducer,
    categoryReducer: categoryReducer,
    subcategoryReducer: subcategoryReducer,
    userReducer: userReducer,
    shippingReducer: shippingReducer,
    addressReducer: addressReducer,
    ordersReducer: ordersReducer,
    brandReducer: brandReducer,
    resourceReducer: resourceReducer,
    statisticsReducer: statisticsReducer,
    prescriptionReducer: prescriptionReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'POST_LOGOUT') {
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducer;